import React from 'react';
import * as Q from './questions';

export interface SkillProfile {
  name: string;
  description: string;
}

export interface AssessmentViewProps {
  formValues: Q.FormValues;
  profiles_html: string;
}

export const AssessmentView: React.FC<AssessmentViewProps> = (props) => {
  return (
    <>
      <div className="block">
        <div className="assessment" dangerouslySetInnerHTML={{ __html: props.profiles_html }} />
      </div>
      <h2 className="title is-4">Vastauksesi</h2>
      <p className="block">
        1 = ei lainkaan <br />
        2 = vähän <br />
        3 = jonkin verran <br />
        4 = hyvin <br />
        5 = erittäin hyvin <br />
      </p>
      <div className="columns">
        <div className="column is-three-quarters-widescreen">
          <table className="table">
            <tbody>
              {Object.entries(Q.allLikerts).map(([key, question]) => (
                <tr key={key}>
                  <td>{question}</td>
                  <td>
                    <b>{props.formValues[key as Q.LikertName]}</b>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
